export default "/images/seafoam_lightbulb.png?1ab7d01bad10adf1f9c0ded7667eef98";